module.exports = __webpack_public_path__ + "th.791d65462ea97d4a0a6e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/th.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/th.svg
// module chunks = styles